import {RequestType, UyapRequest} from "./UyapRequest";
import {IcraTebligatTalebiAdresSorgulaCevap} from "./IcraTebligatTalebiAdresSorgula";

export interface PortalIcraTebligatTalebiAdresSorgulaTalep {
    dosyaId: string,
    kisiKurumId: number,
    adresTuru: string
}

/**
 * Tebligat talebindeki borçlu adresini portalın yaptığı gibi sorgular (DEV-3519).
 *
 * İstek, TDT-3528 HAR'ındaki portal isteğinin aynısı: kök yol, JSON gövde
 * {dosyaId, kisiKurumId, adresTuru}, kayitId yok. Eski IcraTebligatTalebiAdresSorgula
 * `main/jsp/avukat/` yolunu ve üçüncü şahıs kayitId'sini kullanıyor. O sınıfı 89/1 akışları
 * kullandığı için değiştirilmedi.
 *
 * Kayıt bulunamadığında da 200 döner; adres ve ilAdi boştur.
 */
export default class PortalIcraTebligatTalebiAdresSorgula extends UyapRequest<PortalIcraTebligatTalebiAdresSorgulaTalep, IcraTebligatTalebiAdresSorgulaCevap> {
    // Geçici hatada tekrar DENENMEZ: sorgu başarısız olursa görevdeki adresle devam ediliyor.
    // Tekrar deneme her zaman aşımında dosyaya ~90 sn bekleme ekler, sonucu değiştirmez.
    getMethod(): "POST" | "GET" {
        return "POST";
    }

    getRequestType(): RequestType {
        return "json";
    }

    getSpinnerMessage() {
        return "Tebligat adresi sorgulanıyor...";
    }

    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + "getIcraTebligatTalebiAdresSorgula.ajx";
    }

    async parse(data: any): Promise<IcraTebligatTalebiAdresSorgulaCevap> {
        return data;
    }

    getMockResponse(): any {
        const adresTuru = this.talepData ? this.talepData.adresTuru : "";
        const ortak = {"eklenebilirAdresMi": false, "kayitliAdresMi": false, "aktifAdresmi": false, "guncellendiMi": false};
        if (adresTuru === "ADRTR00013")
            return Object.assign({"adres": "25111-87111-48111", "adresTuru": adresTuru, "adresTuruAciklama": "E-Tebligat Adresi"}, ortak);
        if (adresTuru === "ADRTR00011")
            return Object.assign({"adres": "ÖRNEK MAH. ÖRNEK SK. NO:1 İSTANBUL", "adresTuru": adresTuru, "adresTuruAciklama": "Mersis Adresi"}, ortak);
        return {
            "ilKodu": 80,
            "ilAdi": "OSMANİYE",
            "ilceAdi": "MERKEZ",
            "ilceKodu": 1,
            "adres": "",
            "adresTuru": "ADRTR00008",
            "adresTuruAciklama": "Mernis Adresi",
            "girisTarihi": "31/10/2022",
            "eklenebilirAdresMi": false,
            "kayitliAdresMi": false,
            "aktifAdresmi": false,
            "guncellendiMi": false
        };
    }
}
